"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isPrimaryYAxis = void 0;
exports.isPrimaryYAxis = function (yAxis) { return !yAxis.opposite; };
//# sourceMappingURL=isPrimaryYAxis.js.map